/** Журнал действий: фильтры аккаунт/действие/поиск + пагинация (порт logTable, стр. 4831-4877). */
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";

import * as api from "@/api/orders-planning";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const PAGE = 100;

export function ActionLogView(): React.ReactElement {
  const [username, setUsername] = useState("");
  const [action, setAction] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(PAGE);
  useEffect(() => {
    const t = setTimeout(() => setSearch(searchInput), 250);
    return () => clearTimeout(t);
  }, [searchInput]);

  const q = useQuery({
    queryKey: ["orders", "log", username, action, search, limit],
    queryFn: () =>
      api.listLog({
        ...(username ? { username } : {}),
        ...(action ? { action } : {}),
        ...(search ? { search } : {}),
        limit,
      }),
  });
  // справочники фильтров — из широкой первой страницы
  const meta = useQuery({
    queryKey: ["orders", "log", "meta"],
    queryFn: () => api.listLog({ limit: 500 }),
    staleTime: 60_000,
  });
  const users = [...new Set((meta.data?.items ?? []).map((i) => i.username).filter(Boolean))].sort();
  const actions = [...new Set((meta.data?.items ?? []).map((i) => i.action))].sort((a, b) =>
    a.localeCompare(b, "ru"),
  );

  return (
    <div className="space-y-2 rounded-md border bg-card p-3">
      <div className="flex flex-wrap items-center gap-2">
        <div className="text-sm font-medium">Журнал действий</div>
        <span className="text-xs text-muted-foreground">
          всего: {q.data?.total ?? "…"} · показано: {q.data?.items.length ?? 0}
        </span>
        <div className="ml-auto flex flex-wrap gap-2">
          <select
            className="h-8 rounded border bg-background px-1.5 text-xs"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          >
            <option value="">Аккаунт: все</option>
            {users.map((u) => (
              <option key={u} value={u}>{u}</option>
            ))}
          </select>
          <select
            className="h-8 max-w-56 rounded border bg-background px-1.5 text-xs"
            value={action}
            onChange={(e) => setAction(e.target.value)}
          >
            <option value="">Действие: все</option>
            {actions.map((a) => (
              <option key={a} value={a}>{a}</option>
            ))}
          </select>
          <Input
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            placeholder="Поиск"
            className="h-8 w-48"
          />
        </div>
      </div>
      <div className="max-h-[calc(100vh-330px)] overflow-auto rounded border">
        <table className="w-full text-xs">
          <thead className="sticky top-0 bg-background">
            <tr className="border-b text-muted-foreground">
              <th className="px-2 py-1.5 text-left font-medium">Дата</th>
              <th className="px-2 py-1.5 text-left font-medium">Аккаунт</th>
              <th className="px-2 py-1.5 text-left font-medium">Действие</th>
              <th className="px-2 py-1.5 text-left font-medium">Детали</th>
            </tr>
          </thead>
          <tbody>
            {(q.data?.items ?? []).map((item) => (
              <tr key={item.id} className="border-b last:border-0">
                <td className="whitespace-nowrap px-2 py-1 text-muted-foreground">
                  {new Date(item.ts).toLocaleString("ru-RU")}
                </td>
                <td className="px-2 py-1">{item.username || "—"}</td>
                <td className="px-2 py-1">{item.action}</td>
                <td className="max-w-96 truncate px-2 py-1" title={item.details}>
                  {item.details}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {(q.data?.total ?? 0) > limit && (
        <Button variant="outline" size="sm" onClick={() => setLimit((l) => l + PAGE)}>
          Показать ещё
        </Button>
      )}
    </div>
  );
}
